import { makeTheme } from './themeUtils';

const color = {
    grey1: '#898989',
    grey2: '#ECECEC',
    warning: '#d53d16',
};

const defaultTheme = {
    color, // use US english spelling
};

export { defaultTheme };

// make a theme with the default colors
export default makeTheme(defaultTheme, '#00cece', '#0079a1');
